import {Injectable, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {Hlsjs} from '../../engine/playable/hlsjs';
import {PlayableFactoryService} from '../../ui/video-panel/playable-factory.service';
import {Store} from '@ngxs/store';

@Injectable()
export class AnalyticsService implements OnDestroy {
  private timer: any;
  private gaq: any | null;
  private playable: Hlsjs;
  private subscription: Subscription | undefined;

  constructor(private store: Store, private playableFactory: PlayableFactoryService) {
    this.gaq = window['_gaq'] || this;

    this.store
      .select(state => state.player.isLive).pipe(filter(a => a))
      .subscribe(data => this.bindEvents());
  }

  attach() {
    // NOP?
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.playable = null;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private push(...args) {
    console.log('push', ...args);
  }

  private reportView() {
    this.gaq.push(['_trackEvent', 'GGPlayer', 'watching']);
  }

  private reportStalled() {
    this.gaq.push(['_trackEvent', 'GGPlayer', 'stalled']);
  }

  private bindEvents() {
    if (this.playable) {
      this.ngOnDestroy();
    }

    this.timer = setInterval(() => this.reportView(), 60000);
    this.playable = this.playableFactory.getCurrentPlayable() as Hlsjs;

    // this.subscription = this.playable.stalled$.subscribe(data => this.reportStalled());
    this.reportView();
  }
}
